import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetAdminUserProgressResponse } from './get-admin-user-progress-response';
import { getAdminUserProgressResponseSchema } from './get-admin-user-progress-response';

export async function getAdminUserProgressApi(
  userId: string,
): Promise<IValidatedResponse<IGetAdminUserProgressResponse>> {
  return getRequest<IGetAdminUserProgressResponse>({
    path: `/sys/progress/users/${userId}`,
    schema: getAdminUserProgressResponseSchema,
  });
}
